import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogActions, DialogContent } from "@material-ui/core";

import AppBarModal from "../../general/AppBarModal";

/**
 * Marco de los formularios de solicitud: el mismo modal de la Solicitud de
 * grado, con la barra roja, el titulo y "Cerrar".
 *
 * Los botones (`acciones`) van fuera del contenido, en el pie: asi siguen a la
 * vista aunque la lista de estudiantes de un grupo obligue a hacer scroll.
 *
 * `menu` se pinta entre la barra y el contenido, sin margenes, que es donde
 * los demas modulos ponen las pestañas de un detalle.
 *
 * `animarEntrada` en false sirve cuando este modal reemplaza a otro que ya
 * estaba abierto (el de "cargando" al editar): sin animacion, el cambio se ve
 * como un cambio de contenido y no como un cierre y una apertura.
 */
const ModalSolicitud = ({
  titulo,
  onCerrar,
  menu,
  acciones,
  animarEntrada,
  ancho,
  children,
}) => (
  <Dialog
    open
    fullWidth
    maxWidth={ancho}
    scroll="paper"
    transitionDuration={animarEntrada ? undefined : 0}
    // Un clic fuera del modal no lo cierra: se perderia un formulario a medio
    // llenar. Se cierra con "Cerrar", la X o la tecla Escape.
    onClose={(_evento, motivo) => motivo !== "backdropClick" && onCerrar()}
  >
    <AppBarModal
      titulo={titulo}
      mostrarModal={onCerrar}
      titulo_accion="Cerrar"
      accion={onCerrar}
    />
    {menu}
    <DialogContent>{children}</DialogContent>
    {acciones && <DialogActions>{acciones}</DialogActions>}
  </Dialog>
);

ModalSolicitud.propTypes = {
  titulo: PropTypes.string.isRequired,
  onCerrar: PropTypes.func.isRequired,
  acciones: PropTypes.node,
  menu: PropTypes.node,
  animarEntrada: PropTypes.bool,
  ancho: PropTypes.oneOf(["xs", "sm", "md"]),
  children: PropTypes.node,
};

ModalSolicitud.defaultProps = {
  acciones: null,
  menu: null,
  animarEntrada: true,
  ancho: "md",
};

export default ModalSolicitud;
